import React from 'react';

// Para cuando una llamada a la API falla (ej. el server no responde, o
// devuelve un error de negocio). Distinto del ErrorBoundary: esto se usa
// DENTRO del render normal del componente, antes de llegar a usar los
// datos, así nunca se intenta hacer .map() sobre algo que no llegó bien.
export function EstadoError({ mensaje, onReintentar }) {
  return (
    <div
      style={{
        padding: '30px',
        textAlign: 'center',
        backgroundColor: '#fef2f2',
        border: '1px solid #fecaca',
        borderRadius: '12px',
        color: '#991b1b',
      }}
    >
      <div style={{ fontSize: '28px', marginBottom: '8px' }}>⚠️</div>
      <p style={{ margin: '0 0 14px 0', fontSize: '14px' }}>{mensaje}</p>
      {onReintentar && (
        <button
          onClick={onReintentar}
          style={{
            padding: '8px 18px',
            backgroundColor: '#dc2626',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '13px',
          }}
        >
          Reintentar
        </button>
      )}
    </div>
  );
}
